/* BakerX Scroll Reveal — IntersectionObserver
   Adds .is-visible to .bx-reveal, .bx-reveal--left, .bx-reveal--right
   when elements enter the viewport.
   In Shopify theme editor (designMode), reveals fire instantly. */

(function () {
  var SELECTOR = '.bx-reveal, .bx-reveal--left, .bx-reveal--right';
  var CLASS    = 'is-visible';

  function revealAll() {
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      el.classList.add(CLASS);
    });
  }

  /* Theme editor: skip animation, show everything immediately */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('DOMContentLoaded', revealAll);
    document.addEventListener('shopify:section:load', revealAll);
    return;
  }

  function init() {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add(CLASS);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll(SELECTOR).forEach(function (el) {
      observer.observe(el);
    });

    /* Re-observe any sections loaded dynamically in the editor */
    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll(SELECTOR + ':not(.' + CLASS + ')').forEach(function (el) {
        observer.observe(el);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
